import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from ".././../../service/authentication.service";
import { HomeService } from ".././../../service/home.service";
import { PageService } from ".././../../service/page.service";
import { BannerService } from ".././../../service/banner.service";
import { CategoryService } from ".././../../service/category.service";
import { AmenitiesService } from ".././../../service/amenities.service";
import { environment } from ".././../../../environments/environment";
import { SWIPER_CONFIG } from "ngx-swiper-wrapper";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"]
})
export class HomeComponent implements OnInit {
  users: any;
  home: any;
  pages: any;
  backgroundUrl: String;
  userCount: any;
  categorydata: any;
  selectedCategory: any;
  selectedCategoryamenities: any;
  amenitiesdata: any;
  url: any;
  amenitity_image_url: any;

  public categoryconfig: SwiperConfigInterface = {
    direction: "horizontal",
    slidesPerView: 6,
    navigation: true,
    breakpoints: {
      // when window width is <= 320px
      375: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      // when window width is <= 480px
      480: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      // when window width is <= 640px
      640: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      800: {
        slidesPerView: 4,
        spaceBetween: 40
      }
    },
    autoplay: false
  };

  public categoryinfoconfig: SwiperConfigInterface = {
    direction: "horizontal",
    slidesPerView: 1,
    navigation: false,
    keyboard: false
  };

  constructor(
    private authService: AuthenticationService,
    private service: HomeService,
    private categoryservice: CategoryService,
    private amenitiesservice: AmenitiesService,
    private data: PageService,
    private banner: BannerService
  ) {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.url = environment.apiUrl;

    this.amenitity_image_url = environment.apiUrl + "/assets/uploads/";

    this.authService.getUserinfo().subscribe(res => {
      this.users = res;
    });

    this.categoryservice.getContent().subscribe(res => {
      this.categorydata = res;
      this.selectedCategory = this.categorydata[0].category_name;
      this.selectedCategoryamenities = this.categorydata[0].amenities.split(
        ","
      );
    });

    this.amenitiesservice.getContent().subscribe(res => {
      this.amenitiesdata = res;
    });

    this.service.getContent().subscribe(res => {
      this.home = res;
    });

    this.banner.getUserBanner().subscribe(res => {
      this.pages = res;
      if (this.pages.image) {
        this.backgroundUrl =
          environment.apiUrl + "/assets/banner/" + this.pages.image;
      } else {
        this.backgroundUrl =
          environment.apiUrl +
          "/assets/frontend/images/driver/driver_banner.jpg";
      }
    });

    this.banner.getUserCount().subscribe(res => {
      this.userCount = res;
    });
  }

  chooseCategory(index,categoryName) {
    this.selectedCategory = categoryName;
    this.selectedCategoryamenities = this.categorydata[index].amenities.split(
      ","
    );
  }
}
